<a class="shortcut-menu__button" href="https://fn-log.nfv.surf.net/p/login/" target="_blank">
  <svg-icon src="assets/images/icons/out.svg"></svg-icon>
  <span>{{ "ShortcutMenu.FortiAnalyzer" | translate }} </span>
</a>
